import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './QRGenerator.css';

const QRGenerator = () => {
  const [songs] = useState([
    { id: 'song1', name: 'Dave Grohl', s3Key: 'songs/dave_grohl.mp3' },
    { id: 'song2', name: 'Sample Audio 2', s3Key: 'songs/Guido_Vitale.wav' },
    { id: 'song3', name: 'Sample Audio 3', s3Key: 'songs/Harry_Belafonte.wav' },
  ]);

  const [selectedSong, setSelectedSong] = useState(null);

  const generateQRUrl = (songId) => {
    const baseUrl = window.location.origin;
    return `${baseUrl}/play/${songId}`;
  };

  return (
    <div className="qr-generator">
      <h2>Generate QR Code for Songs</h2>

      <div className="song-list">
        <h3>Available Songs:</h3>
        {songs.map(song => (
          <div key={song.id} className="song-item">
            <button
              onClick={() => setSelectedSong(song)}
              className={selectedSong?.id === song.id ? 'selected' : ''}
            >
              {song.name}
            </button>
          </div>
        ))}
      </div>

      {selectedSong && (
        <div className="qr-display">
          <h3>QR Code for: {selectedSong.name}</h3>
          <div className="qr-code-container">
            <QRCodeSVG
              value={generateQRUrl(selectedSong.id)}
              size={256}
              level="H"
              includeMargin={true}
            />
          </div>
          <p className="qr-url">URL: {generateQRUrl(selectedSong.id)}</p>
          <p className="instructions">
            Scan this QR code to play the song on any device!
          </p>
        </div>
      )}
    </div>
  );
};

export default QRGenerator;